import { combineLifecycleHooks } from 'plugins/pluginUtils';
import { PosPlugin } from 'plugins/plugin';

import {
  clearPreviousCustomerId,
  savePreviousCustomerIdToLocalStorage,
  withPreviousCustomerButton,
} from './features/previousCustomer';
import {
  AddressSearch,
  WithAddressSearchButton,
} from './features/customerForm/addressSearch';
import { registerGeneratedCardNumber } from './features/customerForm/customerCardNumber';
import {
  addSeniorTagToCustomer,
  applySeniorPromotion,
} from './features/customerForm/seniorStatus';
import UICustomerFormBeta from './features/customerForm/UICustomerFormBeta';
import { getCustomTranslations } from './translations';
import { Config, Configuration, getConfiguration } from './configuration';
import { pluginID, modals } from './constants';
import documentation from './documentation.md';

const mmPlugin: PosPlugin<Config> = {
  id: pluginID,
  name: 'M&M customizations',
  keywords: ['mm', 'm&m'],
  infoMDUrl: documentation,
  getStatus: state => {
    const config = getConfiguration(state);
    return !config.seniorPromotionID
      ? { type: 'error', message: 'Senior promotion not selected' }
      : { type: 'valid', message: 'Ready' };
  },
  ComponentConfigurationByLevel: {
    Company: Configuration,
  },
  combineConfiguration: c => ({
    isProduction: false,
    seniorPromotionID: 0,
    ...c,
  }),

  onSaveSalesDocument: {
    after: savePreviousCustomerIdToLocalStorage,
  },
  onCloseDay: {
    after: clearPreviousCustomerId,
  },
  selectorOverrides: {
    getFunctionButtons: withPreviousCustomerButton,
  },

  UIAddressFormBeta: WithAddressSearchButton,

  components: {
    [modals.ADDRESS_SEARCH]: AddressSearch,
  },

  getTranslationOverrides: getCustomTranslations,

  onSaveCustomer: combineLifecycleHooks(
    {
      after: registerGeneratedCardNumber,
    },
    { after: addSeniorTagToCustomer },
  ),
  onSetCustomer: {
    after: applySeniorPromotion,
  },
  UICustomerFormBeta,
};

export default mmPlugin;
